const LOCALE = 'ru-RU';

export const formatMoney = (value) => {
  if (!Number.isFinite(value)) return '—';
  return `${Math.round(value).toLocaleString(LOCALE)} ₸`;
};

/** Крупные суммы в читаемом виде: 3 200 000 ₸ → 3,2 млн ₸ */
export const formatMoneyShort = (value) => {
  if (!Number.isFinite(value)) return '—';

  const abs = Math.abs(value);

  if (abs >= 1000000000) {
    return `${(value / 1000000000).toLocaleString(LOCALE, { maximumFractionDigits: 1 })} млрд ₸`;
  }
  if (abs >= 1000000) {
    return `${(value / 1000000).toLocaleString(LOCALE, { maximumFractionDigits: 1 })} млн ₸`;
  }
  if (abs >= 100000) {
    return `${Math.round(value / 1000).toLocaleString(LOCALE)} тыс ₸`;
  }

  return formatMoney(value);
};

export const formatNumber = (value, digits = 0) => {
  if (!Number.isFinite(value)) return '—';
  return value.toLocaleString(LOCALE, { maximumFractionDigits: digits });
};

export const formatPercent = (value, digits = 0) => {
  if (!Number.isFinite(value)) return '—';
  return `${value.toLocaleString(LOCALE, { maximumFractionDigits: digits })}%`;
};

export const formatSignedPercent = (value, digits = 0) => {
  if (!Number.isFinite(value)) return '—';
  const sign = value > 0 ? '+' : '';
  return `${sign}${formatPercent(value, digits)}`;
};

export const formatMultiplier = (value) => {
  if (!Number.isFinite(value)) return '—';
  return `×${value.toLocaleString(LOCALE, { maximumFractionDigits: 2 })}`;
};

/** Значение рычага в его единицах: чек в тенге, конверсия в процентах. */
export const formatLeverValue = (leverId, value) => {
  if (!Number.isFinite(value)) return '—';

  switch (leverId) {
    case 'p':
      return formatMoney(value);
    case 'c':
      return formatPercent(value * 100, 1);
    case 'l':
      return `${formatNumber(value)} обращений`;
    case 'q':
      return `${formatNumber(value, 1)} раз`;
    default:
      return formatNumber(value);
  }
};

export const parseNumericInput = (raw) => {
  if (raw === '' || raw === null || raw === undefined) return '';
  const cleaned = String(raw).replace(/\s/g, '').replace(',', '.');
  if (cleaned === '' || cleaned === '-') return cleaned;
  const parsed = Number(cleaned);
  if (!Number.isFinite(parsed)) return '';
  // Защита от экстремальных значений / Infinity-трюков
  if (Math.abs(parsed) > 1e12) return parsed > 0 ? 1e12 : -1e12;
  return parsed;
};

export const pluralize = (count, forms) => {
  const n = Math.abs(Math.round(count)) % 100;
  const n1 = n % 10;

  if (n > 10 && n < 20) return forms[2];
  if (n1 > 1 && n1 < 5) return forms[1];
  if (n1 === 1) return forms[0];
  return forms[2];
};
